/**
 * =============================================================================
 * geo-product-delivery.js 
 * =============================================================================
 * Show a banner on the PDP about delivery info. Was previously an FR feature
 * =============================================================================
 */

var GeoProductDelivery = {

  onReady: function(){
    // Only on product page
    if(!MP.Utilities.isProductPage()){
      return;
    }
    document.addEventListener('geodata:loaded', this.handleGeodataLoaded.bind(this));
  },

  handleGeodataLoaded: function(event) {
    var geodataJSON = event.detail.data;
    var isoCode = geodataJSON.country.iso_code;

    // Check we have the banner on page
    var pdpFreeDeliveryBanner = document.getElementById("product-free-delivery-banner");
    if(pdpFreeDeliveryBanner === null){
      return;
    }

    // Check if we're in an excluded country
    var excludedCountries = pdpFreeDeliveryBanner.dataset.excludedCountries.split(",");
    if(excludedCountries.includes(isoCode)){
      return;
    }

    // Get the banner elements
    var specificBanner = document.querySelector('#product-free-delivery-banner [data-applicable-countries*="'+isoCode+'"]');
    var rotwBanner = document.querySelector('#product-free-delivery-banner [data-applicable-countries="rotw"]');

    // Update banner messages to show the user's current country in place of {{ country }}
    var allBanners = document.querySelectorAll('#product-free-delivery-banner > [data-applicable-countries]');
    allBanners.forEach(function(element){
      element.innerHTML = element.innerHTML.replace("{{ country }}", isoCode);
    });

    // console.log('specificBanner', specificBanner);

    // Unhide the relevant banner - either matching our locale, or the generic ROTW banner
    if(specificBanner !== null){
      specificBanner.classList.remove("d-none");
    } else {
      rotwBanner.classList.remove("d-none");
    }
  }
};

export default GeoProductDelivery;